export default "__VITE_ASSET__32uUK0tk__"